import React, { useState } from 'react';
import '../styles.css'; // Ensure you import your CSS file

const Experience = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null); // State to track hovered row

    const experiences = [
        {
            time: "Jan 2025 - Present",
            title: "Game Solution Programmer @ AESIR Limited",
            description: "Developed multiple game solutions including WordyPals, MindVoyage, and more for clients using Unity and C#. Collaborated with clients to gather requirements and deliver solutions on time."
        },
        {
            time: "Jun 2024 - Aug 2024",
            title: "Game Enhancement and Promotion Scheme Intern @ Leap Studio Limited",
            description: "Participated in the closed beta testing process to identify bugs, enhancing the overall gameplay experience through user feedback."
        },
        {
            time: "Jun 2023 - Aug 2023",
            title: "Digital Art and Technology Trainee @ AESIR Limited",
            description: "Worked with a team of developers to create multiple AR and VR products for diverse groups of people with special needs using Unity."
        },
    ];

    return (
        <section id="experience">
            <div className="container hidden">
                <h2 className="title">Work Experience</h2>

                {experiences.map((experience, index) => (
                    <div
                        key={index}
                        className={`experience-row ${hoveredIndex === index ? 'hovered' : hoveredIndex === null ? 'default' : ''}`} // Apply hovered class
                        onMouseEnter={() => setHoveredIndex(index)} // Set hovered index on mouse enter
                        onMouseLeave={() => setHoveredIndex(null)} // Reset hovered index on mouse leave
                    >
                        <div className="experience-time">
                            <p><strong>{experience.time}</strong></p>
                        </div>
                        <div className="experience-details">
                            <h3>{experience.title}</h3>
                            <p>{experience.description}</p>
                        </div>
                    </div>
                ))}
                
            </div>
        </section >
    );
};

export default Experience;